import { DebounceCallback } from '@/packages/_utils/Events';
import GenericImageGenerator from '@/packages/_utils/GenericImage/GenericImageGenerator';
import { VideoPlayerMixinsDataJSON as MediaGalleryCarouselVideo } from '@owc-packages/VideoPlayer/src/VideoPlayer';
import { GenericImage } from '@owc-utils/GenericImage/Image';
import { MediaGalleryCarouselImage, MediaGalleryCarouselItem, UnifiedFormat } from './MediaGalleryOverlay';

export const isCarouselItemAVideo = (
  carouselItem: MediaGalleryCarouselItem<MediaGalleryCarouselImage | MediaGalleryCarouselVideo>,
): boolean => Boolean((carouselItem.json as MediaGalleryCarouselVideo).videoDetails);

export const transformCarouselToUnifiedFormat = (
  carouselItem: MediaGalleryCarouselItem<MediaGalleryCarouselImage | MediaGalleryCarouselVideo>,
): UnifiedFormat => {
  const { title, description } = carouselItem.itemJson;
  let image;
  if (isCarouselItemAVideo(carouselItem)) {
    const { thumbnail } = carouselItem.json as MediaGalleryCarouselVideo;
    const { source } = thumbnail as GenericImage;
    image = {
      title,
      description,
      src: source,
    };
  } else {
    const rawImageData = (carouselItem as MediaGalleryCarouselItem<MediaGalleryCarouselImage>).json
      .genericImage;
    let imageData;
    if (!rawImageData.isGenerated) {
      imageData = new GenericImageGenerator(rawImageData).imageData;
    } else {
      imageData = rawImageData.imageData;
    }
    image = {
      title,
      description,
      src: imageData.source,
    };
  }
  return image;
};

export const resizeObserverCallback: DebounceCallback<ResizeObserverEntry[]> = (
  args: ResizeObserverEntry[],
) => {
  const [carousel] = args;

  // 16x9 ratio
  const height = carousel.contentRect.width * 0.5625;
  (carousel.target as HTMLElement).style.setProperty('--mediaGalleryRowHeight', `${height}px`);
};
